import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components/macro'
import { generateKey } from 'services/generators'
import Status from 'components/atoms/Status/Status'

const whitelistedLangs = ['pt', 'en']

const PageState = ({ langLinks, stateItems }) => {
  // only show white listed langs
  const filteredItems = stateItems.filter(({ label }) => whitelistedLangs.includes(label))
  return (
    <Wrapper>
      {filteredItems.map(({ label: langKey, value: langState }) => {
        const link = langLinks.find((link) => link.langKey === langKey)
        return (
          <Status
            link={link.link}
            text={langKey}
            status={langState}
            key={generateKey(`${langKey}-${langState}`)}
          />
        )
      })}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`

PageState.propTypes = {
  stateItems: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string
  })),
  langLinks: PropTypes.arrayOf(PropTypes.shape({
    langKey: PropTypes.string,
    link: PropTypes.string
  })),
}

PageState.defaultProps = {
  stateItems: [],
  langLinks: [],
}

export default PageState
